import {
  array,
  boolean,
  coerce,
  enumType,
  literal,
  nullable,
  number,
  object,
  optional,
  record,
  string,
} from "valibot";

export const LocaleSchema = enumType([
  "en",
  "es",
  "fr",
  "pt",
  "pt-pt",
  "pt-br",
  "de",
  "it",
  "nl",
  "pl",
  "ru",
  "ja",
  "zn",
  "bg",
  "cs",
  "da",
  "el",
  "hu",
  "lt",
  "lv",
  "ro",
  "sk",
  "sl",
  "sv",
  "fi",
  "et",
  "zh",
  "ca",
  "en-gb",
]);

export const CommandSchema = object({
  widget: optional(enumType(["open", "close"])),
  showWelcomeMessage: optional(boolean()),
  setWelcomeMessage: optional(string()),
  showStarterQuestions: optional(boolean()),
  setStarterQuestions: optional(array(string())),
  sendMessage: optional(string()),
  activeCampaignEmail: optional(string()),
  authorization: optional(string()),
  inAppMode: optional(boolean()),
});

export const ActionSchema = object({
  urls: optional(array(string())),
  scrollPercentage: optional(number()),
  timeout: optional(number()),
  commands: array(CommandSchema),
});

export const ActionsSchema = array(ActionSchema);

export const ActionsEventSchema = object({
  actions: ActionsSchema,
});

export const ParentWindowSizeSchema = object({
  innerWidth: number(),
  innerHeight: number(),
});

export const ParentWindowScrollSchema = object({
  scrollPercentage: number(),
});

// * for events

export const VariablesEventDetailSchema = record(
  string(),
  coerce(string(), String),
);

export const VariablesEventSchema = object({
  type: literal("set-botsonic-variables"),
  detail: VariablesEventDetailSchema,
});

// * for backend
export const VariableSourceSchema = enumType(["USER_FORM", "CUSTOM"] as const);

export const VariableSchema = object({
  id: string(),
  key: string(),
  fallback: optional(nullable(string())),
  is_deleted: boolean(),
  source: VariableSourceSchema,
});

export const BotVariablesSchema = object({
  _id: string(),
  bot_id: string(),
  created_at: string(),
  updated_at: string(),
  variables: array(VariableSchema),
});

// * for frontend states
const VariableStateSchema = object({
  key: string(),
  value: string(),
  fallback: optional(nullable(string())),
});

export const VariablesRecordSchema = record(string(), VariableStateSchema);
